module.exports = __webpack_public_path__ + "img/youxue.60f8f79f.png";